import { FC } from 'react'

import './style.scss'

type LineProps = {
  className?: string,
  fullWidth?: boolean
}

const Line:FC<LineProps> = ({ className, fullWidth }) => {
  return (
    <hr className={`line ${fullWidth ? 'w-full' : ''} ${className}`} />
  )
}

export { Line }